(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["GroupsListWidgetController"] = factory();
	else
		root["GroupsListWidgetController"] = factory();
})(self, () => {
return 